import { render, staticRenderFns } from "./societyIndex.vue?vue&type=template&id=e424e88a&scoped=true"
import script from "./societyIndex.vue?vue&type=script&lang=js"
export * from "./societyIndex.vue?vue&type=script&lang=js"
import style0 from "./societyIndex.vue?vue&type=style&index=0&id=e424e88a&prod&lang=css"
import style1 from "./societyIndex.vue?vue&type=style&index=1&id=e424e88a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e424e88a",
  null
  
)

export default component.exports